import { InvoiceContractRepository } from '../domain/InvoiceContractRepository'
import { InvoiceContractScreenData } from '../domain/InvoiceContractScreenData'


export class InvoiceContractComponent {

  invoice_contract_repo: InvoiceContractRepository
  screen_data: InvoiceContractScreenData
 

  constructor(invoice_contract_repo, screen_data) {
      this.invoice_contract_repo = invoice_contract_repo
      this.screen_data = screen_data      
  }

  async activateEInvoiceTrialContract(company_id) {
    this.screen_data.setLoading(true)
    try {
      let res = await this.invoice_contract_repo.activate_trial_einvoice_contract(company_id)
      return res
    } finally {
      this.screen_data.setLoading(false)
    }
  }

  async checkEInvoiceContractShowTrial(company_id) {
    let res = await this.invoice_contract_repo.check_user_einvoice_active_contract(company_id)
    this.screen_data.setShowTrial(!res)    
  }
}